import styled, { keyframes, css } from 'styled-components';
import { colors } from 'components/styles/_variables';
import { respondTo } from 'components/styles/_respondTo';

const loaderColor = colors.theme.white;

export const StyledButton = styled.button`
  position: relative;
  border: ${({ color }) =>
    color === 'primary_white' ? 'solid 1px #FF7828' : 'none'};
  padding: ${({ p }) => p};
  border-radius: 8px;
  background-color: ${({ color }) => colors.theme[color || 'primary']};
  min-width: 144px;
  width: ${({ width }) => (width ? width : 'auto')};
  min-height: ${({ height }) => (height ? 'auto' : '44px')};
  height: ${({ height }) => (height ? height : 'auto')};
  max-width: ${({ maxW }) => maxW || 'auto'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.23px;
  color: ${({ color }) => (color === 'primary_white' ? '#FF7828' : '#ffffff')};
  cursor: ${({ loading }) => (loading ? 'not-allowed' : 'pointer')};
  margin: ${({ mr = 0, ml = 0, mt = 0, mb = 0 }) =>
    `${mt}px ${mr}px ${mb}px ${ml}px`};
  flex: ${({ flex }) => flex};
  ${respondTo.desktop`
    max-width: ${({ maxW = 155 }) => maxW}px;
    max-height: 44px;
  `}

  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.7;
  }

  ${({ isCancel }) =>
    isCancel &&
    css`
      transition: 0.2s ease all;
      &:hover {
        background-color: #2f2f2f;
      }
    `}
`;

const dotPulse = keyframes`
  0% {
    box-shadow: 9999px 0 0 -5px ${loaderColor};
  }
  30% {
    box-shadow: 9999px 0 0 2px ${loaderColor};
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px ${loaderColor};
  }
`;

const dotPulseBefore = keyframes`
  0% {
    box-shadow: 9984px 0 0 -5px ${loaderColor};
  }
  30% {
    box-shadow: 9984px 0 0 2px ${loaderColor};
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px ${loaderColor};
  }
`;

const dotPulseAfter = keyframes`
  
  0% {
    box-shadow: 10014px 0 0 -5px ${loaderColor};
  }
  30% {
    box-shadow: 10014px 0 0 2px ${loaderColor};
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px ${loaderColor};
  }
`;

export const LoadingWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 2rem 0;
  margin: 0 -5%;
  overflow: hidden;
`;

export const Loading = styled.div`
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: ${loaderColor};
  color: ${loaderColor};
  box-shadow: 9999px 0 0 -5px ${loaderColor};
  animation: ${dotPulse} 1.5s infinite linear;
  animation-delay: 0.25s;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${loaderColor};
    color: ${loaderColor};
  }

  &::before {
    box-shadow: 9984px 0 0 -5px ${loaderColor};
    animation: ${dotPulseBefore} 1.5s infinite linear;
    animation-delay: 0s;
  }

  &::after {
    box-shadow: 10014px 0 0 -5px ${loaderColor};
    animation: ${dotPulseAfter} 1.5s infinite linear;
    animation-delay: 0.5s;
  }
`;
